module.exports = __webpack_public_path__ + "img/ricelog_pinicon_051.be469ea5.png";